var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCelebratePeopleCommunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.4598 26.7171C39.8093 25.1923 36.3698 23.9512 32.3781 23.9512C28.3864 23.9512 24.947 25.1923 22.2964 26.7171C21.5265 27.1627 20.8816 27.8393 20.4332 28.6719C19.9848 29.5044 19.7505 30.4603 19.7562 31.4334V41.5122H31.4431H45V31.4334C45 29.4476 44.0376 27.6214 42.4598 26.7171Z",
    fill: "#256BE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2818 19.0743H28.8219C23.2911 19.0743 23.9026 4.19512 32.5519 4.19512C41.4458 4.19512 41.298 19.0743 36.2818 19.0743Z",
    fill: "#256BE4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4928 24.0693C20.0039 24.2856 19.5279 24.5072 19.0649 24.7328C17.6529 25.4251 16.4699 26.4764 15.6475 27.7699C14.825 29.0634 14.3952 30.5486 14.4057 32.0605V41.6837L14.4055 41.6837H0.000121206V31.2705C-0.00664936 30.2545 0.270355 29.2566 0.800387 28.3874C1.33042 27.5183 2.09275 26.8119 3.00275 26.3467C6.13593 24.7548 10.2016 23.4591 14.92 23.4591C16.8994 23.4591 18.7638 23.6871 20.4928 24.0693Z",
    fill: "#171C8F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9147 18.4634H9.32928C6.59636 18.4634 4.39026 16.2573 4.39026 13.5244C4.39026 12.3226 4.83477 11.2195 5.55916 10.3634C5.34514 9.82012 5.21343 9.21098 5.21343 8.58537C5.21505 7.60747 5.50692 6.65206 6.05206 5.84021C6.59721 5.02835 7.37108 4.3966 8.27562 4.025C9.32928 2.79024 10.8768 2 12.622 2C14.3671 2 15.9147 2.79024 16.9683 4.025C17.8729 4.3966 18.6467 5.02835 19.1919 5.84021C19.737 6.65206 20.0289 7.60747 20.0305 8.58537C20.0305 9.21098 19.8988 9.82012 19.6848 10.3634C20.4092 11.2195 20.8537 12.3226 20.8537 13.5244C20.8537 16.2573 18.6476 18.4634 15.9147 18.4634Z",
    fill: "#171C8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelebratePeopleCommunity);
export default __webpack_public_path__ + "static/media/CelebratePeople&Community.4b57da6fdf9d8e622a77f0e4f1c3b825.svg";
export { ForwardRef as ReactComponent };